module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/feature_articles-55e44b468ca797a6cebdb2cea59550cb.svg";